import React, { useEffect, useMemo, useState } from 'react';
import { ButtonUI, DialogUI, FormLabelUI, InputUI, TabsUI } from '../../Interface';
import { Box } from '@mui/material';
import CheckListAttachmentDialog from './CheckListAttachmentDialog';

const DescriptionPanel = ({ valuesState, data }) => {
  const { values, setValues } = valuesState;
  return (
    <div>
      <div className="col-span-full relative">
        <div className="mt-2">
          <InputUI
            className={`resize-none h-36, p-2`}
            fullWidth
            label={<FormLabelUI text={data?.descriptionName ?? 'Megjegyzés'} />}
            variant="standard"
            multiline
            rows={4}
            value={values.description}
            onChange={(e) =>
              setValues((prev) => ({
                ...prev,
                description: e.target.value,
              }))
            }
          />
        </div>
      </div>
    </div>
  );
};

const CheckListMandatoryDialog = ({ open, handleClose, data, changeCheckedStatus }) => {
  const [values, setValues] = useState({
    description: data?.description,
    itemAttachment: data?.itemAttachment,
  });

  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (data) {
      setValues({
        description: data.description ?? '',
        itemAttachment: data.itemAttachment,
      });
    }
  }, [data?.id]);

  const handleSaveClick = async () => {
    await changeCheckedStatus(data, true, values);
    handleClose();
  };

  const tabs = [
    ...(data?.descriptionRequired
      ? [
          {
            id: 0,
            name: 'Leírás',
            content: <DescriptionPanel valuesState={{ values, setValues }} data={data} />,
          },
        ]
      : []),
    ...(data?.attachRequired
      ? [
          {
            id: 1,
            name: 'Csatolmány',
            content: <CheckListAttachmentDialog valuesState={{ values, setValues }} />,
          },
        ]
      : []),
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const descReq = !!data?.descriptionRequired;
  const attachReq = !!data?.attachRequired;

  const hasDescription = (values.description ?? '').trim().length > 0;
  const hasAttachment = Array.isArray(values.itemAttachment) && values.itemAttachment.length > 0;

  const isSaveEnabled = useMemo(() => {
    if (descReq && attachReq) return hasDescription && hasAttachment; // mindkettő kötelező
    if (descReq) return hasDescription; // csak leírás kötelező
    if (attachReq) return hasAttachment; // csak csatolmány kötelező
    return true; // egyik sem kötelező
  }, [descReq, attachReq, hasDescription, hasAttachment]);

  return (
    <DialogUI
      open={open}
      headerContent="Checklista kötelezőség"
      onClose={handleClose}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <Box mt="1rem">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </Box>

      <Box display="flex" gap="0.5rem" justifyContent="center">
        <ButtonUI text="Rögzítés" className="bg-success" onClick={() => handleSaveClick()} disabled={!isSaveEnabled} />
        <ButtonUI text="Mégse" className="bg-primary" onClick={handleClose} />
      </Box>
    </DialogUI>
  );
};

export default CheckListMandatoryDialog;
